import * as React from 'react';
export var QuizContext = React.createContext([]);
export var QuizProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(), questions = _b[0], setQuestions = _b[1];
    var _c = React.useState(0), currentQuizIndex = _c[0], setCurrentQuizIndex = _c[1];
    var value = [questions, currentQuizIndex, setQuestions, setCurrentQuizIndex];
    return React.createElement(QuizContext.Provider, { value: value }, children);
};
